import { styled } from 'goober';
import { COLORS } from '@shared/config/colors/colors';

export const Wrapper = styled('footer')`
    width: 100%;
    background-color: ${COLORS.neutral_05};
`;

export const SizeContainer = styled('div')`
    display: flex;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;
    padding: 20px 40px;
    align-items: center;
    justify-content: center;
`;

export const LinksItem = styled('div')`
    display: flex;
`;

export const LinksContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-basis: 80%;
    width: 100%;

    ${LinksItem} {
        &:last-child {
            justify-content: flex-end;
        }
    }
`;

export const LinksList = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const StyledLink = styled('a')`
    display: inline-flex;
    color: ${COLORS.light_primary};
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;

    &:hover {
        color: ${COLORS.neutral_90};
    }
`;
